module.exports = __webpack_public_path__ + "img/durable_medical_equipment.3c1d9318.svg";